import { getParameters } from '../../../helpers/helpers';
import { CARD_FORM } from './form-card-type';

import HandleAddCard from './newCard/create-new-card';
import HandleViewOrEditCard from './existingCard/get-card-info';

/**
 * Handles routing for the card form page.
 * 
 * @returns void
 */
export const formCards = () => {
  if(!CARD_FORM.cardForm) return;

  const formAction = getParameters('cardAction');

  switch (formAction) {
    case 'Add':
      HandleAddCard();
      break;
    case 'Edit':
    case 'View':
      HandleViewOrEditCard();
      break;
  }
}